import type { TabDefinition } from './types';

export const FOR_YOU_TAB_ID = 'for-you';

export const SUGGESTIONS_TAB_ID = 'suggestions';

export type RovoTabsProps = {
	/**
	 * Array of tab definitions to render
	 */
	tabs: TabDefinition[];
	/**
	 * ID of the currently selected tab. The parent owns this state.
	 */
	selectedTab: string;
	/**
	 * Called when the user selects a different tab.
	 */
	onTabChange: (tabId: string) => void;
	hideTabStrip?: boolean;
};

export type RovoTabId = typeof SUGGESTIONS_TAB_ID | typeof FOR_YOU_TAB_ID;
